
// ─────────────────────────────────────────────
// COMPONENT 4: TechStackMarquee
// PLACEMENT: Between #services section and #solutions section
// Usage: <TechStackMarquee />
// ─────────────────────────────────────────────
const TECH_STACK = [
  { label: "Python", icon: "🐍" },
  { label: "React", icon: "⚛️" },
  { label: "AWS", icon: "☁️" },
  { label: "PostgreSQL", icon: "🐘" },
  { label: "Docker", icon: "🐳" },
  { label: "OpenAI", icon: "🤖" },
  { label: "Kubernetes", icon: "⚙️" },
  { label: "Odoo ERP", icon: "📦" },
  { label: "Terraform", icon: "🏗️" },
  { label: "GraphQL", icon: "◈" },
  { label: "Next.js", icon: "▲" },
  { label: "LangChain", icon: "🔗" },
];

export function TechStackMarquee() {
  // Duplicate for seamless loop
  const items = [...TECH_STACK, ...TECH_STACK];

  return (
    <>
      <style>{`
        .rs-marquee-outer {
          overflow: hidden;
          padding: 22px 0;
          border-top: 1px solid #1D3145;
          border-bottom: 1px solid #1D3145;
          position: relative;
          z-index: 3;
        }
        .rs-marquee-outer::before,
        .rs-marquee-outer::after {
          content: '';
          position: absolute;
          top: 0; bottom: 0;
          width: 80px;
          z-index: 2;
        }
        .rs-marquee-outer::before { left: 0; background: linear-gradient(90deg, #05070A, transparent); }
        .rs-marquee-outer::after  { right: 0; background: linear-gradient(-90deg, #05070A, transparent); }
        .rs-marquee-track {
          display: flex;
          gap: 52px;
          width: max-content;
          animation: rsMarquee 20s linear infinite;
        }
        .rs-marquee-track:hover { animation-play-state: paused; }
        @keyframes rsMarquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .rs-marquee-item {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 600;
          font-size: 14px;
          color: #A7B3C2;
          letter-spacing: 0.05em;
          white-space: nowrap;
          display: flex;
          align-items: center;
          gap: 9px;
          opacity: 0.6;
          transition: opacity 0.3s, color 0.3s;
          cursor: default;
        }
        .rs-marquee-item:hover { opacity: 1; color: #49D6FF; }
        .rs-marquee-icon { font-size: 16px; }
      `}</style>
      <div className="rs-marquee-outer">
        <div className="rs-marquee-track">
          {items.map((t, i) => (
            <span className="rs-marquee-item" key={i}>
              <span className="rs-marquee-icon">{t.icon}</span>
              {t.label}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
